// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GeWhitelistAddPatientRequestModel {
    'clientWhiteListId': string;
    'ndcList': Array<string>;
    'startDate': Moment;
    'endDate'?: Moment;
    'systemId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GeWhitelistAddPatientRequestModel>> = [
        {
            "name":     "clientWhiteListId",
            "baseName": "clientWhiteListId",
            "type":     "string"
        },
        {
            "name":     "ndcList",
            "baseName": "ndcList",
            "type":     "Array<string>"
        },
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "Date"
        },
        {
            "name":     "endDate",
            "baseName": "endDate",
            "type":     "Date"
        },
        {
            "name":     "systemId",
            "baseName": "systemId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return GeWhitelistAddPatientRequestModel.attributeTypeMap;
    }
}
